module.exports = __webpack_public_path__ + "img/cottonbro.d12f5eb1.jpg";